<template>
  <div :class="['rb-choices', `rb-${data.type}`]">
    <!-- <div :class="['rb-unselected-warn', { 'rb-active': showInactiveNotice }]">Please make a selection to move to the next step</div> -->
    <div class="rb-choices-carousel-header" v-if="carousel">
      <div class="rb-choice-display" v-if="selected">
        <span>{{ titleDisplay }}</span
        >&nbsp;
        <span>{{ selected.label }}</span>
      </div>
      <div class="rb-choices-nav">
        <span>Showing {{ currentSlide + 1 }}/{{ data.choices.length }}</span>
        <div>
          <button
            class="rb-choice-carousel-btn"
            aria-label="Previous"
            @click.prevent="prevSlide"
          >
            <icon-arrow-left />
          </button>
          <button
            class="rb-choice-carousel-btn"
            aria-label="Next"
            @click.prevent="nextSlide"
          >
            <icon-arrow-right />
          </button>
        </div>
      </div>
    </div>
    <div class="rb-title-display" v-if="enableTitle">
      <div>
        <span>{{ titleDisplay }}: </span>
        <span>{{ selected?.label || "" }}</span>
      </div>
      <div v-if="helpId">
        <step-help
          :show-help-title="false"
          help-title=""
          :show-label="false"
          :label="'Precious Metal'"
          :popup-id="helpId"
        />
      </div>
    </div>
    <div class="rb-choices-carousel" v-if="carousel">
      <div class="keen-slider" ref="elChoicesSlider">
        <div
          class="keen-slider__slide"
          v-for="choice in data.choices"
          :key="`choice-slider-${data.id}-${choice.id}`"
        >
          <button
            @click.prevent="selectChoice(deleteKey(data, 'choices'), choice)"
            :id="`step-${data.id}--choice-${slugify(choice.label)}`"
            :aria-label="`Select ${choice.label}`"
            :class="[
              'rb-btn-choice',
              { 'rb-active': selected && selected.id === choice.id },
            ]"
          >
            <div class="rb-image">
              <img
                :src="choice.image"
                v-if="choice.image"
                :alt="choice.label"
                class="lazyload"
                loading="lazy"
              />
              <div class="rb-price-badge" v-if="choice.additionalPrice">
                {{ (choice.additionalPrice / 100) | money }}
              </div>
            </div>
            <span>{{
              choice.labelDisplay ? choice.labelDisplay : choice.label
            }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="rb-choices-wrap" v-if="!carousel">
      <button
        v-for="choice in data.choices"
        :key="`choice-${data.id}-${choice.id}`"
        :aria-label="`Select ${choice.label}`"
        @click.prevent="
          selectChoice(
            deleteKey(data, 'choices'),
            choice,
            `step-${data.id}--choice-${slugify(choice.label)}`
          )
        "
        :id="`step-${data.id}--choice-${slugify(choice.label)}`"
        :class="[
          'rb-btn-choice',
          { 'rb-active': selected && selected.id === choice.id },
          { 'rb-disabled': !isAvailableChoice(choice.id) },
        ]"
      >
        <div class="rb-image">
          <img
            :src="choice.image"
            v-if="choice.image"
            :alt="choice.label"
            class="lazyload"
            loading="lazy"
          />
          <div class="rb-price-badge" v-if="choice.additionalPrice">
            {{ (choice.additionalPrice / 100) | money }}
          </div>
        </div>
        <span>{{
          choice.labelDisplay ? choice.labelDisplay : choice.label
        }}</span>
      </button>
    </div>
    <div class="rb-choices-wrap rb-choices-wrap-mobile">
      <select
        :value="selected?.id || null"
        @change="notifySelectChoice"
        :id="`step-${data.id}`"
      >
        <option :value="null" v-if="!selected">Select</option>
        <option
          v-for="choice in data.choices"
          :value="choice.id"
          :key="`select-choice-${data.id}-${choice.id}`"
        >
          {{ choice.label }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
/**
 * Widget to display a set of choices for the current step
 *
 * @summary
 * It implements both button and dropdown versions
 *
 * @props
 * carousel: Boolean
 * product: Object
 * mappings: Object
 * availability: Array
 * enableNoticeWarn: Boolean
 * enableTitle: Boolean
 * titleDisplay: String
 *
 * @implements
 * ChildMixin
 * CommMixin
 * FormattersMixin
 * TrackMixin
 *
 * @emits
 * rb-step-complete
 * rb-step-incomplete
 */
import KeenSlider from "keen-slider";
import ChildMixin from "@/mixins/ChildMixin";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import FormattersMixin from "@/mixins/FormattersMixin";
import IconArrowLeft from "@/components/icons/IconArrowLeft";
import IconArrowRight from "@/components/icons/IconArrowRight";
import StepHelp from "@/components/StepHelp";
import { deleteKey, slugify } from "../lib";
export default {
  mixins: [ChildMixin, CommMixin, FormattersMixin, TrackMixin],
  components: {
    IconArrowLeft,
    IconArrowRight,
    StepHelp,
  },
  props: {
    carousel: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
    },
    mappings: {
      type: Object,
    },
    availability: {
      type: Array,
      default: () => [],
    },
    enableNoticeWarn: {
      type: Boolean,
      default: true,
    },
    enableTitle: {
      type: Boolean,
      default: false,
    },
    titleDisplay: {
      type: String,
      default: "",
    },
    helpId: {
      type: String,
      default: "",
    },
  },
  computed: {
    selected: function () {
      return (
        this.selectedOptions.find(
          (selectedOption) => selectedOption.step.id === this.data.id
        )?.choice || null
      );
    },
  },
  mounted: function () {
    if (this.carousel) {
      this.startCarousel();
    }
    // this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
  },
  data: function () {
    return {
      started: false,
      slider: null,
      currentSlide: 0,
      // showInactiveNotice: false,
      // alreadySelected: false,
    };
  },
  methods: {
    /* onStepDisplayUpdate: function () {

      this.showInactiveNotice = false;
      if (this.enableNoticeWarn) {
        setTimeout(() => {
          if (!this.alreadySelected) {
            this.showInactiveNotice = true;
          }
        }, 10000)
      }
    }, */
    isAvailableChoice: function (choiceId) {
      // Check availability rules exist
      // console.log(this.availability);
      var stepAvailability = this.availability.find(
        (av) => av.stepId === this.data.id
      );
      // console.log("stepAvailability", stepAvailability);
      // If there are no availability rules for this step, then option is available
      if (!stepAvailability) return true;

      // if there are availability rules, then check the option exists
      var optionIndex = this.availability.findIndex(
        (av) => av.stepId === this.data.id
      );
      // optionIndex = optionIndex - 1;
      // console.log(optionIndex, this.data.id);
      // Getting availabilityId for this step <prevChoiceId>:<choiceId>
      // console.log(this.selectedOptions, optionIndex);
      // I have to force to original order
      var forceOrder = [
        "shape",
        "metal",
        "signature",
        "size",
        "engraving",
        "diamond",
      ];
      var orderedSelectedOptions = forceOrder
        .map((fo) =>
          this.selectedOptions.find(
            (selectedOption) => selectedOption.step.id == fo
          )
        )
        .filter((v) => v);
      // console.log(orderedSelectedOptions);

      var prev = [];
      if (optionIndex > -1) {
        prev = [...orderedSelectedOptions]
          // prev = [...this.selectedOptions]
          .splice(0, optionIndex)
          .map((selectedOption) => selectedOption.choice.id);
      }
      // console.log("prev", prev);
      var availabilityId = `${
        prev.length > 0 ? prev.join(":") + ":" : ""
      }${choiceId}`;

      // console.log("av", availabilityId);

      return stepAvailability.available.find((av) => {
        return av === availabilityId;
      })
        ? true
        : false;
    },
    notifySelectChoice: function (event) {
      if (event.target.value) {
        this.alreadySelected = true;
        var selectValue = this.data.choices.find(
          (choice) => parseInt(choice.id) === parseInt(event.target.value)
        );
        this.selectChoice(this.deleteKey(this.data, "choices"), selectValue);
        this.trackEvent(
          this.formatTracking(
            `${event.target.id}--choice-${slugify(selectValue.label)}`
          ),
          this.deuniquefyId(
            `${event.target.id}--choice-${slugify(selectValue.label)}`
          ),
          {
            [this.getTrackingOption(this.mappings.tracking, this.data.id)]:
              selectValue.label,
          }
        );
      } else {
        this.unselectChoice();
      }
    },
    selectChoice: function (data, choice, id) {
      this.trackEvent(this.formatTracking(id), this.deuniquefyId(id), {
        [this.getTrackingOption(this.mappings.tracking, data.id)]: choice.label,
      });
      this.broadcast("rb-step-complete", { step: data, choice });
    },
    unselectChoice: function () {
      this.broadcast("rb-step-complete", { step: this.data });
    },
    deleteKey: function (obj, key) {
      return deleteKey(obj, key);
    },
    startCarousel: function () {
      if (this.started) return;
      setTimeout(() => {
        this.initSlider();
        this.started = true;
      }, 250);
    },
    initSlider: function () {
      this.slider = new KeenSlider(this.$refs.elChoicesSlider, {
        loop: false,
        slides: { perView: 6 },
        created: () => {
          // console.log("created");
        },
        slideChanged: this.slideChanged,
      });
    },
    prevSlide: function () {
      this.slider.prev();
    },
    nextSlide: function () {
      this.slider.next();
    },
    gotoSlide: function (idx) {
      this.slider.moveToIdx(idx);
    },
    slideChanged: function (slider) {
      this.currentSlide = slider.track.details.abs;
    },
    slugify: function (str) {
      return slugify(str);
    },
  },
};
</script>
